/* istanbul ignore file */
export { default } from './Auth';
